export default {
  id: null,
  email: null,
  fullname: null,
  phone_number: null,
  work_in: null,
  role: null,
  status: null,
  signup: null,
  activated: null,
  last_login: null,
  credits: null,
  keywords_count: 6,
  projects_count: 2,
  reports_count: 0,
  links_count: 0,
  permissions: null,
  overridden_permissions: null,
  projects: null
}



// WEBPACK FOOTER //
// ./src/store/user/state.js